Object.defineProperty(window, '$$define', {
	enumerable: true,
	get: function() {
		return function(obj, key, value, isEnumerable = true) {
			Object.defineProperty(obj, key, {
				enumerable: isEnumerable,
				get: function() {
					return value;
				}
			});
		};
	}
});

window.$$define(window, '$define', function(key, value, isEnumerable = true) {
	window.$$define(window, '$' + key, value, isEnumerable);
});
